import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import accountService from "../Services/accountService";
import incomeService from "../Services/incomeService";
import customerService from "../Services/customerService";
import moment from "moment";
import orderService from "../Services/orderService";
import Dropdown from "../Components/Dropdown";
import Select from "react-select";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddIncome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const passedCustomerId = location.state?.customerId?.toString();
  console.log("Passed customerId from location:", passedCustomerId);
  const [responseError, setResponseError] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const passedOrderIds = location.state?.orderIds; // keep as undefined if not present
  const passedAmount = location.state?.amount ?? "";

  const [data, setData] = useState({
    customer: "",
    amount: "",
    account: "",
    note: "",
    date: "",
    voucher: "",
    order_id: "",
  });

  const [errors, setErrors] = useState({
    customer: false,
    amount: false,
    account: false,
    note: false,
    date: false,
    voucher: false,
    order_id: false,
  });

  const [regex, setRegex] = useState({
    customer: /.{1,50}$/,
    amount: /.{1,50}$/,
    account: /.{1,50}$/,
    note: /.{1,50}$/,
    date: /.{1,50}$/,
    voucher: /.{1,50}$/,
    // order_id: /^[0-9]*$/,
    order_id: /^.*$/,
  });

  // useEffect(() => {
  //   customerService.fetchAll().then(async (res) => {
  //     setCustomers(res.customers);

  //     if (passedCustomerId) {
  //       const customerExists = res.customers.some(
  //         (c) => c.id.toString() === passedCustomerId
  //       );

  //       if (customerExists) {
  //         setData((prev) => ({ ...prev, customer: passedCustomerId, amount:location.state?.amount || "", }));
  //         try {
  //           const res = await orderService.fetchCustomerUnpaid(passedCustomerId);
  //           if (res?.orders) {
  //             setOrders(res.orders);
  //           }
  //         } catch (error) {
  //           toast.error("Failed to load orders.");
  //         }
  //       }
  //     }
  //   });

  //   accountService.fetchAllActiveAccounts().then((res) => {
  //     setAccounts(res.accounts);
  //   });
  // }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        const customerRes = await customerService.fetchAll();
        setCustomers(customerRes.customers);

        const accountRes = await accountService.fetchAllActiveAccounts();
        setAccounts(accountRes.accounts);

        if (passedCustomerId) {
          const customerExists = customerRes.customers.some(
            (c) => c.id.toString() === passedCustomerId,
          );

          if (customerExists) {
            setData((prev) => ({
              ...prev,
              customer: passedCustomerId,
              amount: passedAmount || "",
            }));

            const orderRes =
              await orderService.fetchCustomerUnpaid(passedCustomerId);
            if (orderRes?.orders) {
              setOrders(orderRes.orders);

              // ✅ Check passedOrderIds safely (it may be undefined now)
              if (Array.isArray(passedOrderIds) && passedOrderIds.length > 0) {
                const validOrderIds = orderRes.orders
                  .filter((o) => passedOrderIds.includes(o.id.toString()))
                  .map((o) => o.id.toString());

                setData((prev) => ({
                  ...prev,
                  order_id:
                    validOrderIds.length > 0 ? validOrderIds : ["open_order"],
                }));
              }
            }
          }
        }
      } catch (error) {
        toast.error("Failed to load initial data.");
        console.error(error);
      }
    };

    initialize();
  }, [passedCustomerId]); // ✅ Only depend on the stable primitive string

  const handleChange = async (v, n) => {
    if (n === "date" && v > moment().format("YYYY-MM-DD")) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    if (n === "amount" && v < 0) {
      return;
    }

    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));

    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }

    // Load unpaid orders when customer is selected
    if (n === "customer") {
      try {
        const res = await orderService.fetchCustomerUnpaid(v);
        if (res?.orders) {
          setOrders(res.orders);
        }
      } catch (error) {
        console.error("Error fetching customer orders:", error);
      }
    }
  };

  const handleSubmit = () => {
    let hasError = false;

    Object.keys(data).forEach((v) => {
      if (
        v === "order_id" &&
        (data[v].includes("open_order") || data[v].length === 0)
      ) {
        return;
      }

      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      let payload = { ...data };

      // if (payload.order_id.includes("open_order")) {
      //   payload.order_id = null;
      // }

      if (
        !Array.isArray(payload.order_id) ||
        payload.order_id.includes("open_order")
      ) {
        payload.order_id = [];
      }

      setLoading(true);

      incomeService.create(payload).then((res) => {
        if (res.responseCode === 201) {
          toast.error(res.message, { id: "3" });
          setLoading(false);
          return;
        }

        setLoading(false);
        toast.success("Income Added Successfully", { id: "2" });
        navigate("/incomes");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <p className="font-bold text-3xl text-secondary text-center mt-10">
        {" "}
        Add Customer Payment
      </p>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-4">
          <div>
            <label className={`primary-label`}>Customer</label>
            <Dropdown
              selected={data.customer}
              placeholder="Select Customer"
              onChange={(value) => handleChange(value, "customer")}
              options={customers.map((customer) => ({
                label: customer.company_name,
                value: customer.id.toString(),
              }))}
            />
          </div>

          <div>
            <label className="primary-label">Customer Orders (Unpaid)</label>
            <Select
              isMulti
              options={[
                { label: "Open Order", value: "open_order" },
                ...orders.map((order) => ({
                  label: `Order #${order.id} - Balance: ${order.balance}`,
                  value: order.id.toString(),
                })),
              ]}
              value={
                Array.isArray(data.order_id)
                  ? data.order_id.map((id) => {
                      if (id === "open_order")
                        return { label: "Open Order", value: "open_order" };
                      const order = orders.find((o) => o.id.toString() === id);
                      return {
                        label: `Order #${order?.id} - Balance: ${order?.balance}`,
                        value: id,
                      };
                    })
                  : []
              }
              onChange={(selected) => {
                const selectedValues = selected.map((s) => s.value);
                if (selectedValues.includes("open_order")) {
                  setData((d) => ({ ...d, order_id: ["open_order"] }));
                } else {
                  setData((d) => ({ ...d, order_id: selectedValues }));
                }
              }}
              isOptionDisabled={(option) =>
                data.order_id?.includes("open_order") &&
                option.value !== "open_order"
              }
              placeholder="Select Order(s)"
            />
          </div>

          <div>
            <label className={`primary-label`}>Account</label>
            <Dropdown
              selected={data.account}
              placeholder="Select Account"
              onChange={(value) => handleChange(value, "account")}
              options={accounts.map((acc) => ({
                label: `${acc.account_name} - ${acc.account_title}`,
                value: acc.id,
              }))}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-4 md:gap-4 mt-4">
          <div>
            <label className={`primary-label`}>Amount</label>
            <input
              value={data.amount}
              name="amount"
              type="number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["amount"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Voucher Type</label>
            <Dropdown
              selected={data.voucher}
              placeholder="Select Voucher Type"
              onChange={(value) => handleChange(value, "voucher")}
              options={[
                { label: "CASH RECEIPT VOUCHER", value: "CRV" },
                { label: "BANK RECEIPT VOUCHER", value: "BRV" },
              ]}
            />
          </div>
          <div>
            <label className={`primary-label`}>Date</label>
            <input
              value={data.date}
              type="date"
              name="date"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="date"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["date"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Note</label>
            <input
              value={data.note}
              name="note"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["note"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>

        <div className="flex items-center justify-center mt-10">
          <SecondaryButton
            text={loading ? <LoadingDots /> : "Add"}
            Icon={FiPlus}
            color="!px-16"
            onClick={() => handleSubmit()}
          />
        </div>
      </div>
    </main>
  );
};

export default AddIncome;
